import { doc, DocumentReference } from 'firebase/firestore';
import { docData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IRange, IUser } from '../../types';
import { authenticatedUserProvider } from '../userProvider';

export interface ITestsSetting {
  range?: IRange | null;
  facet?: string | null;
}

/**
 * @description provides the date range the user wants to see tests from
 * @returns
 */
export const testsSettingProvider = (): Observable<ITestsSetting> => {
  return authenticatedUserProvider().pipe(
    switchMap((user: IUser): Observable<ITestsSetting> => {
      return docData<ITestsSetting>(
        doc(
          user.services.firestore,
          `userProfiles/${user.id}/settings/tests`
        ) as DocumentReference<ITestsSetting>
      ).pipe(
        map((setting: ITestsSetting): ITestsSetting => {
          return setting;
        })
      );
    })
  );
};
